import React, { Component } from 'react';
import FormCreate from './FormCreate';
import FormCreateCondition from './FormCreateCondition';
import Swal from "sweetalert2/dist/sweetalert2.js";

class Index extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
            showForm: false,
            modeEdit: false,
            editAggregation: null,
            conditionCreateForId: "",
            conditionEditId: "",
        };
    }

    componentDidMount = () => {
        this.loadData();
    }

    messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    loadData = () => {
        fetch(`/formatos/get_format_aggregations/${this.props.format.id}`, {
            method: 'GET',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                data: data.data,
                isLoaded: false
            });
        });
    }

    handleCreated = (register) => {
        this.setState({
            data: [...this.state.data, register],
            showForm: false,
            modeEdit: false,
            editAggregation: null,
        });
    }

    handleUpdated = (register) => {
        this.setState({
            data: this.state.data.map(item => item.id === register.id ? register : item),
            showForm: false,
            modeEdit: false,
            editAggregation: null,
        });
    }

    handleEdit = (aggregation) => {
        this.setState({
            showForm: true,
            modeEdit: true,
            editAggregation: aggregation,
        });
    }

    handleDelete = (id) => {
        Swal.fire({
            title: "Eliminar agregacion?",
            text: "El registro sera eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_aggregations/${id}`, {
                    method: 'DELETE',
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                .then(r => r.json())
                .then(response => {
                    this.setState({
                        data: this.state.data.filter(item => item.id !== id)
                    });
                    this.messageSuccess(response);
                });
            }
        });
    }

    // === Condition CRUD ===
    handleConditionCreated = (aggId, register) => {
        this.setState({
            conditionCreateForId: "",
            data: this.state.data.map(d => {
                if (d.id === aggId) {
                    return { ...d, format_aggregation_conditions: [...(d.format_aggregation_conditions || []), register] };
                }
                return d;
            })
        });
    }

    handleConditionUpdated = (aggId, register) => {
        this.setState({
            conditionEditId: "",
            data: this.state.data.map(d => {
                if (d.id === aggId) {
                    return {
                        ...d,
                        format_aggregation_conditions: (d.format_aggregation_conditions || []).map(c =>
                            c.id === register.id ? register : c
                        )
                    };
                }
                return d;
            })
        });
    }

    deleteCondition = (aggId, conditionId) => {
        Swal.fire({ title: "Eliminar condicion?", type: "warning", showCancelButton: true, confirmButtonText: "Si", cancelButtonText: "Cancelar" }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_aggregation_conditions/${conditionId}`, {
                    method: 'DELETE',
                    headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
                })
                .then(r => r.json())
                .then(data => {
                    Swal.fire({ position: "center", type: data.type, title: data.success, showConfirmButton: false, timer: 1500 });
                    this.setState({
                        data: this.state.data.map(d => {
                            if (d.id === aggId) {
                                return { ...d, format_aggregation_conditions: (d.format_aggregation_conditions || []).filter(c => c.id !== conditionId) };
                            }
                            return d;
                        })
                    });
                });
            }
        });
    }

    getOperationLabel = (operation) => {
        const labels = {
            suma: 'Suma',
            promedio: 'Promedio',
            maximo: 'Maximo',
            minimo: 'Minimo',
            contador: 'Contador',
            valor: 'Valor',
            ultimo: 'Ultimo',
            primero: 'Primero',
        };
        return labels[operation] || operation;
    }

    render() {
        const styeleIcons = {
            fontSize: "16px",
            color: "#3f69d8",
            cursor: "pointer",
        };

        return (
            <div>
                {this.state.showForm && !this.state.modeEdit && (
                    <FormCreate
                        key="new"
                        format={this.props.format}
                        formatos={this.props.formatos}
                        modeEdit={false}
                        aggregation={null}
                        onCreated={this.handleCreated}
                        onUpdated={this.handleUpdated}
                        onClose={() => this.setState({ showForm: false, modeEdit: false, editAggregation: null })}
                    />
                )}

                <div className="col-md-12 mb-3 text-right pr-0">
                    {!this.state.showForm && (
                        <button
                            className="btn-shadow btn btn-info"
                            onClick={() => this.setState({ showForm: true, modeEdit: false, editAggregation: null })}
                        >
                            <i className="fas fa-plus mr-1" /> Nueva agregacion
                        </button>
                    )}
                </div>

                {this.state.data.length >= 1 ? (
                    this.state.data.map((aggregation) => (
                        <div className="card mb-3" key={aggregation.id}>
                            {this.state.modeEdit && this.state.editAggregation && this.state.editAggregation.id === aggregation.id ? (
                                <div style={{ padding: '12px 16px' }}>
                                    <FormCreate
                                        key={`edit-${aggregation.id}`}
                                        format={this.props.format}
                                        formatos={this.props.formatos}
                                        modeEdit={true}
                                        aggregation={aggregation}
                                        onCreated={this.handleCreated}
                                        onUpdated={this.handleUpdated}
                                        onClose={() => this.setState({ showForm: false, modeEdit: false, editAggregation: null })}
                                    />
                                </div>
                            ) : (
                            <React.Fragment>
                            <div style={{ display: "block", padding: '12px 16px', borderBottom: '1px solid #e5e7eb' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                    <span style={{ fontWeight: 600, fontSize: 14 }}>Configuracion de agregacion</span>
                                    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                        <button className="btn btn-sm" onClick={() => this.handleEdit(aggregation)}>
                                            <i className="fas fa-pencil-alt" style={styeleIcons} />
                                        </button>
                                        <button className="btn btn-sm" onClick={() => this.handleDelete(aggregation.id)}>
                                            <i className="fas fa-trash-alt" style={styeleIcons} />
                                        </button>
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 24px' }}>
                                    <div>
                                        <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Pregunta objetivo</span>
                                        <span style={{ fontSize: 13, fontWeight: 500 }}>{aggregation.question_target_info ? aggregation.question_target_info.name : '-'}</span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Operacion</span>
                                        <span style={{ fontSize: 13, fontWeight: 500 }}>{this.getOperationLabel(aggregation.operation)}</span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Formato fuente</span>
                                        <span style={{ fontSize: 13, fontWeight: 500 }}>{aggregation.format_source_info ? aggregation.format_source_info.name : '-'}</span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Pregunta fuente</span>
                                        <span style={{ fontSize: 13, fontWeight: 500 }}>{aggregation.question_source_info ? aggregation.question_source_info.name : '-'}</span>
                                    </div>
                                </div>

                                <div style={{ marginTop: 8, padding: '6px 10px', background: '#f0f7ff', borderRadius: 4, fontSize: 13 }}>
                                    <span style={{ fontWeight: 500 }}>{aggregation.question_target_info ? aggregation.question_target_info.name : '?'}</span>
                                    <span style={{ color: '#999', margin: '0 6px' }}>=</span>
                                    <span style={{ color: '#3498db', fontWeight: 500 }}>{this.getOperationLabel(aggregation.operation)}</span>
                                    <span style={{ color: '#999', margin: '0 6px' }}>de</span>
                                    <span style={{ fontWeight: 500 }}>{aggregation.question_source_info ? aggregation.question_source_info.name : '?'}</span>
                                    <span style={{ color: '#999', margin: '0 4px' }}>(</span>
                                    <span style={{ color: '#e67e22', fontWeight: 500 }}>{aggregation.format_source_info ? aggregation.format_source_info.name : '?'}</span>
                                    <span style={{ color: '#999' }}>)</span>
                                </div>
                            </div>

                            {/* === Conditions Section === */}
                            <div style={{ padding: '8px 16px', background: '#f9fafb' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                    <span style={{ fontSize: 12, fontWeight: 600, color: '#666' }}>Condiciones ({(aggregation.format_aggregation_conditions || []).length})</span>
                                    <div>
                                        {this.state.conditionCreateForId === aggregation.id && (
                                            <FormCreateCondition
                                                isOpen={true}
                                                target={`PopoverCreateAggCondition${aggregation.id}`}
                                                format_aggregation={aggregation}
                                                modeEdit={false}
                                                existingConditionsCount={(aggregation.format_aggregation_conditions || []).length}
                                                onCreated={(register) => this.handleConditionCreated(aggregation.id, register)}
                                                onClose={() => this.setState({ conditionCreateForId: "" })}
                                            />
                                        )}
                                        <button
                                            className="btn btn-info btn-sm"
                                            id={`PopoverCreateAggCondition${aggregation.id}`}
                                            onClick={() => this.setState({ conditionCreateForId: aggregation.id })}
                                        >
                                            <i className="fas fa-plus mr-1" /> Condicion
                                        </button>
                                    </div>
                                </div>
                                {(aggregation.format_aggregation_conditions || []).length > 0 ? (
                                    <div style={{ fontSize: 13 }}>
                                        {aggregation.format_aggregation_conditions.map((cond, idx) => (
                                            <div key={cond.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', borderBottom: '1px solid #f0f0f0' }}>
                                                {idx > 0 && (
                                                    <span style={{ fontSize: 11, fontWeight: 600, color: cond.conditional === 'O' ? '#e67e22' : '#3498db', minWidth: 24 }}>
                                                        {cond.conditional === 'O' ? 'O' : 'Y'}
                                                    </span>
                                                )}
                                                {idx === 0 && <span style={{ minWidth: 24 }} />}
                                                <span style={{ fontWeight: 500 }}>{cond.question_info.name}</span>
                                                <span style={{ color: '#999', fontSize: 11 }}>{cond.operation}</span>
                                                {cond.compare_mode && cond.compare_mode !== 'value' && cond.question_to_compare_info ? (
                                                    <span style={{ color: '#8e44ad', fontWeight: 500 }}>
                                                        [{cond.question_to_compare_info.name}]
                                                        <span style={{ fontSize: 9, color: '#999', marginLeft: 4 }}>
                                                            {cond.compare_mode === 'question' ? 'mismo registro' : cond.compare_mode}
                                                        </span>
                                                    </span>
                                                ) : (
                                                    <span style={{ color: '#27ae60', fontWeight: 500 }}>"{cond.value && cond.value.includes(',') ? cond.value.split(',').join(' y ') : cond.value}"</span>
                                                )}
                                                <div style={{ marginLeft: 'auto', display: 'flex', gap: 4 }}>
                                                    {this.state.conditionEditId === cond.id && (
                                                        <FormCreateCondition
                                                            isOpen={true}
                                                            target={`PopoverEditAggCondition${cond.id}`}
                                                            format_aggregation={aggregation}
                                                            modeEdit={true}
                                                            condition={cond}
                                                            onUpdated={(register) => this.handleConditionUpdated(aggregation.id, register)}
                                                            onClose={() => this.setState({ conditionEditId: "" })}
                                                        />
                                                    )}
                                                    <button className="btn btn-sm p-0" id={`PopoverEditAggCondition${cond.id}`} onClick={() => this.setState({ conditionEditId: cond.id })}>
                                                        <i className="fas fa-pencil-alt" style={{ ...styeleIcons, fontSize: 12 }} />
                                                    </button>
                                                    <button className="btn btn-sm p-0" onClick={() => this.deleteCondition(aggregation.id, cond.id)}>
                                                        <i className="fas fa-trash-alt" style={{ ...styeleIcons, fontSize: 12 }} />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div style={{ textAlign: 'center', padding: '8px 0', color: '#999', fontSize: 12 }}>
                                        Sin condiciones — se agregaran todos los registros del formato fuente
                                    </div>
                                )}
                            </div>
                            </React.Fragment>
                            )}
                        </div>
                    ))
                ) : (
                    <div className="card">
                        <div className="card-body text-center">
                            <h4>No hay agregaciones configuradas</h4>
                            <p style={{ color: '#999', fontSize: 13 }}>Haz clic en "Nueva agregacion" para crear una.</p>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Index;
